<template>
  <div class="gift-pack-item">
    <div class="gift-pack-item-title">
      <span class="gift-type">{{ giftTypeName }}</span>
      <span class="gift-type-rule"> {{ giftType !== 1 ? "累计" : "" }}邀请{{ ruleNum }}人完成注册{{ `（${finishNum}/${ruleNum}）` }} </span>
    </div>
    <div class="gift-pack-item-content">
      <div class="gift-area">
        <div class="gift-item" :class="[giftType !== 3 ? 'mr-40' : 'mr-20']" v-for="item in giftInfo" :key="item.id">
          <div class="gift-img-item">
            <img class="gift-img" :src="item.url" alt="" />
            <p class="gift-info">
              <span class="gift-name">{{ item.name }}</span>
              <span class="gift-num">x{{ item.count }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="activity-btn" :style="{ opacity: isReceive == 3 ? 0.3 : 1 }" @click="toInvite">
        {{ btnText }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {
    giftType: {
      type: Number,
      default: 1,
    },
    ruleNum: {
      type: Number,
      default: 1,
    },
    finishNum: {
      type: Number,
      default: 0,
    },
    isReceive: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    giftTypeName() {
      let str = "";
      if (this.giftType === 1) {
        str = "精美礼包";
      } else if (this.giftType === 2) {
        str = "白银礼包";
      } else if (this.giftType === 3) {
        str = "黄金礼包";
      }
      return str;
    },
    giftInfo() {
      return this.giftType != 3 ? this.giftList.slice(0, 3) : this.giftList;
    },
    btnText() {
      let str = "";
      // 0、活动关闭 1、可以领取 2、未达领取条件 3已经领取
      if (this.isReceive == 0) {
        str = "活动已关闭";
      } else if (this.isReceive == 1) {
        str = "领取奖励";
      } else if (this.isReceive == 2) {
        str = "立即邀请";
      } else if (this.isReceive == 3) {
        str = "已领取";
      }
      return str;
    },
  },
  data() {
    return {
      invite_link: "",
      giftList: [
        {
          id: "01",
          name: "鹰钻",
          count: this.giftType == 3 ? 50 : this.giftType == 2 ? 20 : 5,
          url: require("./img/duye.png"),
          show: true,
        },
        {
          id: "02",
          name: "来个角球",
          count: this.giftType != 1 ? 10 : 2,
          url: require("./img/jiaoqiu.png"),
          show: true,
        },
        {
          id: "03",
          name: "666",
          count: this.giftType != 1 ? 10 : 2,
          url: require("./img/666.png"),
          show: true,
        },
        {
          id: "04",
          name: "再进一球",
          count: 2,
          url: require("./img/jinqiu.png"),
          show: this.giftType != 3,
        },
      ],
    };
  },
  mounted() {
    const { origin } = window.location;
    const { invite_code } = this.userInfo;
    this.invite_link = `${origin}/?i_code=${invite_code}`;
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    toInvite() {
      if (!this.userInfo.id) {
        this.toggleLogin();
      } else if (this.isReceive == 1) {
        this.$emit("updateGift", this.giftType + 2);
      } else if (this.isReceive != 2) {
        return;
      } else {
        this.$copyText(this.invite_link).then(
          (e) => {
            this.$message.success("邀请链接已复制");
          },
          (e) => {
            this.$message.error("复制失败", e.text);
          }
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gift-pack-item {
  width: 100%;
  height: 220px;
  position: relative;
  background: #f27629;
  box-shadow: inset 0px 2px 6px 0px rgba(255, 235, 75, 0.6), 2px 2px 6px 0px rgba(184, 73, 4, 0.4);
  border-radius: 5px;
  border: 3px solid;
  border-image: linear-gradient(180deg, #f7d695, #ecad5c) 1;
  clip-path: inset(0 round 5px);
  margin-bottom: 16px;

  .gift-pack-item-title {
    width: 100%;
    height: 40px;
    background-image: linear-gradient(135deg, rgba(252, 250, 243, 0.2) 0%, rgba(246, 225, 190, 0.1) 100%);
    border-radius: 8px 8px 0px 0px;
    display: flex;
    align-items: center;
  }

  .gift-type {
    line-height: 22px;
    font-size: 16px;
    color: #ffffff;
    font-weight: 600;
    margin-left: 24px;
  }

  .gift-type-rule {
    line-height: 20px;
    opacity: 0.8;
    font-size: 14px;
    color: #ffffff;
    margin-left: 12px;
  }

  .gift-pack-item-content {
    width: 100%;
    margin-top: 24px;
  }

  .gift-area {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .mr-20 {
    margin-right: 20px;
  }

  .mr-40 {
    margin-right: 40px;
  }

  .gift-item {
    display: flex;
    justify-content: center;
    flex-direction: column;

    &:last-child {
      margin-right: 0;
    }
  }

  .gift-img-item {
    width: 64px;
    height: 64px;
    background: #ffffff;
    box-shadow: inset 0px -2px 3px 0px rgba(213, 87, 9, 0.4);
    border-radius: 4px;
    margin-bottom: 40px;
    position: relative;
  }

  .gift-img {
    width: 100%;
    height: 100%;
  }

  .gift-info {
    width: 88px;
    text-align: center;
    position: absolute;
    top: 68px;
    left: 50%;
    transform: translateX(-50%);
  }

  .gift-name {
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
  }

  .gift-num {
    font-size: 14px;
    color: #ffdc3c;
    font-weight: 500;
  }

  .activity-btn {
    width: 252px;
    height: 48px;
    margin: 0 auto;
    background: url("./img/share_button.png") no-repeat;
    background-size: cover;
    font-size: 18px;
    color: #b51801;
    text-align: center;
    font-weight: 500;
    line-height: 36px;
    cursor: pointer;
  }
}
</style>
